import { render, staticRenderFns } from "./gifText.vue?vue&type=template&id=37082747"
import script from "./gifText.vue?vue&type=script&lang=js"
export * from "./gifText.vue?vue&type=script&lang=js"
import style0 from "./gifText.vue?vue&type=style&index=0&id=37082747&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports